/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddOrGetFreeTagParams,
  BaseResponseAutocompleteResponse,
  BaseResponseDocumentDetailResponse,
  BaseResponseDocumentDuplicateResponse,
  BaseResponseDocumentResponse,
  BaseResponseDocumentTemplateResponse,
  BaseResponseListDocumentCategoryColumnDto,
  BaseResponseListDocumentCategoryDto,
  BaseResponseListDocumentTagCategoryDto,
  BaseResponseListDocumentTempResponse,
  BaseResponseListNoneOrderDocumentClassDto,
  BaseResponseListString,
  BaseResponsePageResponseDocumentDto,
  BaseResponsePageResponseDocumentMyDeskResponse,
  BaseResponseString,
  BaseResponseTempDocumentDetailResponse,
  BaseResponseUUID,
  CheckDuplicateFileParams,
  DocumentApprovalRequest,
  DocumentApproveRequest,
  DocumentAttachmentFileSaveRequest,
  DocumentFileUrlUpdateRequest,
  DocumentSearchRequest,
  DocumentTagUpdateRequest,
  DocumentTempSaveRequest,
  GetArchivesDocumentPageParams,
  GetAutocompleteSuggestionsParams,
  GetDocumentCategoryColumnsParams,
  GetDocumentPageParams,
  GetDocumentsByCategoryParams,
  GetDocumentTagsParams,
  GetDocumentTemplateParams,
  GetMyDeskDocumentCategoriesParams,
  GetTempDocumentsParams,
} from './data-contracts';
import {ContentType, HttpClient, RequestParams} from './http-client';

export class Document<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 기존에 임시 저장된 문서를 수정합니다. 문서 UUID를 기반으로 기존 데이터를 업데이트합니다.
   *
   * @tags Document
   * @name UpdateDocumentTemp
   * @summary 문서 임시 저장 수정
   * @request PUT:/app/documents/temp/{uuid}
   * @secure
   * @response `200` `BaseResponseUUID` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updateDocumentTemp = async (uuid: string, data: DocumentTempSaveRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUUID, void>({
      path: `/app/documents/temp/${uuid}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 주어진 UUID를 기반으로 임시 저장된 문서를 삭제합니다. 관련된 태그, 첨부 파일 데이터도 함께 삭제됩니다.
   *
   * @tags Document
   * @name DeleteDocumentTemp
   * @summary 문서 임시 저장 삭제
   * @request DELETE:/app/documents/temp/{uuid}
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  deleteDocumentTemp = async (uuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/documents/temp/${uuid}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 임시 저장된 문서를 1단계 결재요청 상태로 변경하고 결재자 및 참조자를 설정합니다.
   *
   * @tags Document
   * @name RequestReview
   * @summary 문서 1단계 결재 요청(ANAYLSIS)
   * @request POST:/app/documents/{documentUuid}/review-request
   * @secure
   * @response `200` `BaseResponseUUID` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  requestReview = async (documentUuid: string, data: DocumentApprovalRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUUID, void>({
      path: `/app/documents/${documentUuid}/review-request`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 1단계 결재완료된 문서를 2단계 결재요청 상태로 변경하고 결재자 및 참조자를 설정합니다.
   *
   * @tags Document
   * @name RequestApproval
   * @summary 문서 2단계 결재 요청(WORK, ANALYSIS, ARCHIVES)
   * @request POST:/app/documents/{documentUuid}/approve-request
   * @secure
   * @response `200` `BaseResponseUUID` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  requestApproval = async (documentUuid: string, data: DocumentApprovalRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUUID, void>({
      path: `/app/documents/${documentUuid}/approve-request`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 결재자가 문서 보완요청 및 승인 해주는 API(presignedUrl null 이면 승인 x)
   *
   * @tags Document
   * @name ApprovalAction
   * @summary 결재자의 문서 보완요청 및 승인
   * @request POST:/app/documents/{documentUuid}/approval-action
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  approvalAction = async (documentUuid: string, data: DocumentApproveRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/documents/${documentUuid}/approval-action`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 특정 카테고리(WORK, ANALYSIS, ARCHIVES)의 임시저장된 문서 리스트를 조회합니다.
   *
   * @tags Document
   * @name GetTempDocuments
   * @summary 임시저장 문서 리스트 조회
   * @request GET:/app/documents/temp
   * @secure
   * @response `200` `BaseResponseListDocumentTempResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getTempDocumentsKey = (query: GetTempDocumentsParams) => ['app', 'documents', 'temp', query];

  getTempDocuments = async (query: GetTempDocumentsParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListDocumentTempResponse, void>({
      path: `/app/documents/temp`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서의 임시 저장 상태를 유지하기 위해 `TEMP` 상태의 문서를 저장합니다.
   *
   * @tags Document
   * @name SaveDocumentTemp
   * @summary 문서 임시 저장
   * @request POST:/app/documents/temp
   * @secure
   * @response `201` `BaseResponseUUID` Created
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  saveDocumentTemp = async (data: DocumentTempSaveRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUUID, void>({
      path: `/app/documents/temp`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서를 페이지 형태로 조회합니다. (조건이 들어오면 조건 검색)
   *
   * @tags Document
   * @name GetDocumentPage
   * @summary 문서 페이지 조회
   * @request POST:/app/documents/search
   * @secure
   * @response `200` `BaseResponsePageResponseDocumentDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentPage = async (query: GetDocumentPageParams, data: DocumentSearchRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponsePageResponseDocumentDto, void>({
      path: `/app/documents/search`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 주어진 태그 이름으로 자유 태그를 추가하거나, 이미 존재하는 경우 해당 태그의 UUID를 반환합니다.
   *
   * @tags Document
   * @name AddOrGetFreeTag
   * @summary 자유 태그 추가 또는 검색
   * @request POST:/app/documents/free-tags
   * @secure
   * @response `200` `BaseResponseUUID` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  addOrGetFreeTag = async (query: AddOrGetFreeTagParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseUUID, void>({
      path: `/app/documents/free-tags`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 승인된 문서에 등록된 태그를 수정합니다.
   *
   * @tags Document
   * @name UpdateDocumentTags
   * @summary 문서 태그 수정
   * @request PATCH:/app/documents/{uuid}/tags
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updateDocumentTags = async (uuid: string, data: DocumentTagUpdateRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/documents/${uuid}/tags`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 주어진 UUID에 해당되는 문서의 PDF URL을 갱신합니다.
   *
   * @tags Document
   * @name UpdateDocumentFileUrl
   * @summary 문서 PDF URL 갱신
   * @request PATCH:/app/documents/{uuid}/file-url
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updateDocumentFileUrl = async (uuid: string, data: DocumentFileUrlUpdateRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/documents/${uuid}/file-url`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 주어진 UUID에 해당되는 결재 완료 상태의 문서에 첨부파일을 추가합니다. 작성자나 대표이사만 접근 가능합니다.
   *
   * @tags Document
   * @name SaveAdditionalAttachmentFiles
   * @summary 문서 첨부파일 추가 첨부
   * @request PATCH:/app/documents/{documentUuid}/attachment-files
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  saveAdditionalAttachmentFiles = async (
    documentUuid: string,
    data: DocumentAttachmentFileSaveRequest,
    params: RequestParams = {},
  ) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/documents/${documentUuid}/attachment-files`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 기존 푸시 알림들의 title 값을 문서 카테고리에 맞게 재설정합니다.
   *
   * @tags Document
   * @name UpdatePushNotificationsTitle
   * @summary (사용 금지)푸시 알림 title 재설정
   * @request PATCH:/app/documents/push-notifications
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updatePushNotificationsTitle = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/documents/push-notifications`,
      method: 'PATCH',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서 종류, 작성자에 따라 적절한 조회 권한을 문서에 부여합니다.
   *
   * @tags Document
   * @name UpdateDocumentAuthority
   * @summary (사용 금지)문서 조회 권한 재설정
   * @request PATCH:/app/documents/authority
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updateDocumentAuthority = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/documents/authority`,
      method: 'PATCH',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 기존 결재완료 문서의 첨부파일들의 isMerged 값을 true로 재설정합니다.
   *
   * @tags Document
   * @name UpdateDocumentAttachmentFilesIsMerged
   * @summary (사용 금지)첨부파일 isMerged 재설정
   * @request PATCH:/app/documents/attachment-files
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  updateDocumentAttachmentFilesIsMerged = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/documents/attachment-files`,
      method: 'PATCH',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description DocumentClass UUID를 기반으로 DB에 저장된 JSON 템플릿과 UUID를 제공합니다.
   *
   * @tags Document
   * @name GetDocumentTemplate
   * @summary 문서 양식별 JSON 데이터 제공
   * @request GET:/app/documents/templates
   * @secure
   * @response `200` `BaseResponseDocumentTemplateResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentTemplateKey = (query: GetDocumentTemplateParams) => ['app', 'documents', 'templates', query];

  getDocumentTemplate = async (query: GetDocumentTemplateParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseDocumentTemplateResponse, void>({
      path: `/app/documents/templates`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서 UUID를 사용하여 임시 저장/보완 요청 문서 상세 정보를 조회합니다.
   *
   * @tags Document
   * @name GetTempDocumentDetail
   * @summary 임시 저장/보완 요청 문서 상세 조회
   * @request GET:/app/documents/temp/detail/{uuid}
   * @secure
   * @response `200` `BaseResponseTempDocumentDetailResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getTempDocumentDetailKey = (uuid: string) => ['app', 'documents', 'temp', 'detail', uuid];

  getTempDocumentDetail = async (uuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseTempDocumentDetailResponse, void>({
      path: `/app/documents/temp/detail/${uuid}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서 구분(UUID)으로 선택이 필요한 태그를 조회합니다.
   *
   * @tags Document
   * @name GetDocumentTags
   * @summary 문서 태그 조회
   * @request GET:/app/documents/tags
   * @secure
   * @response `200` `BaseResponseListDocumentTagCategoryDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentTagsKey = (query: GetDocumentTagsParams) => ['app', 'documents', 'tags', query];

  getDocumentTags = async (query: GetDocumentTagsParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListDocumentTagCategoryDto, void>({
      path: `/app/documents/tags`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description DocumentCategory 테이블에서 내가 등록한 문서 종류(name)와 uuid를 반환합니다.
   *
   * @tags Document
   * @name GetMyDeskDocumentCategories
   * @summary 내가 등록한 문서 종류 조회
   * @request GET:/app/documents/mydesk/categories
   * @secure
   * @response `200` `BaseResponseListDocumentCategoryDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getMyDeskDocumentCategoriesKey = (query: GetMyDeskDocumentCategoriesParams) => [
    'app',
    'documents',
    'mydesk',
    'categories',
    query,
  ];

  getMyDeskDocumentCategories = async (query: GetMyDeskDocumentCategoriesParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListDocumentCategoryDto, void>({
      path: `/app/documents/mydesk/categories`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 검색어 자동완성을 제공합니다.
   *
   * @tags Document
   * @name GetAutocompleteSuggestions
   * @summary MY DESK 검색어 자동완성
   * @request GET:/app/documents/my-desk/autocomplete
   * @secure
   * @response `200` `BaseResponseListString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getAutocompleteSuggestionsKey = (query: GetAutocompleteSuggestionsParams) => [
    'app',
    'documents',
    'my-desk',
    'autocomplete',
    query,
  ];

  getAutocompleteSuggestions = async (query: GetAutocompleteSuggestionsParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListString, void>({
      path: `/app/documents/my-desk/autocomplete`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서 UUID를 사용하여 문서 상세 정보를 조회합니다.
   *
   * @tags Document
   * @name GetDocumentDetail
   * @summary 문서 상세 데이터 조회
   * @request GET:/app/documents/detail/{uuid}
   * @secure
   * @response `200` `BaseResponseDocumentDetailResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentDetailKey = (uuid: string) => ['app', 'documents', 'detail', uuid];

  getDocumentDetail = async (uuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseDocumentDetailResponse, void>({
      path: `/app/documents/detail/${uuid}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 파일 이름과 MD5 해시값을 기준으로 중복 파일 여부를 확인합니다.
   *
   * @tags Document
   * @name CheckDuplicateFile
   * @summary 첨부파일 중복 여부 확인
   * @request GET:/app/documents/check-duplicate
   * @secure
   * @response `200` `BaseResponseDocumentDuplicateResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  checkDuplicateFileKey = (query: CheckDuplicateFileParams) => ['app', 'documents', 'check-duplicate', query];

  checkDuplicateFile = async (query: CheckDuplicateFileParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseDocumentDuplicateResponse, void>({
      path: `/app/documents/check-duplicate`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description DocumentCategory 테이블에서 문서 종류(name)와 uuid를 반환합니다.
   *
   * @tags Document
   * @name GetDocumentCategories
   * @summary 문서 종류 조회
   * @request GET:/app/documents/categories
   * @secure
   * @response `200` `BaseResponseListDocumentCategoryDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentCategoriesKey = () => ['app', 'documents', 'categories'];

  getDocumentCategories = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListDocumentCategoryDto, void>({
      path: `/app/documents/categories`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서 카테고리, 날짜 범위, 검색어를 기준으로 문서 목록을 조회합니다. 상태값은 임시저장 / 결재중 / 결재 완료 / 보완 요청 / 등록완료
   *
   * @tags Document
   * @name GetDocumentsByCategory
   * @summary MY DESK 문서 목록 조회
   * @request GET:/app/documents/categories/{categoryUuid}/documents
   * @secure
   * @response `200` `BaseResponsePageResponseDocumentMyDeskResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentsByCategoryKey = ({categoryUuid, ...query}: GetDocumentsByCategoryParams) => [
    'app',
    'documents',
    'categories',
    categoryUuid,
    'documents',
    query,
  ];

  getDocumentsByCategory = async (
    {categoryUuid, ...query}: GetDocumentsByCategoryParams,
    params: RequestParams = {},
  ) => {
    const response = await this.http.request<BaseResponsePageResponseDocumentMyDeskResponse, void>({
      path: `/app/documents/categories/${categoryUuid}/documents`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서 카테고리 UUID를 기반으로 추가 컬럼명과 JSON 키 값을 반환합니다.
   *
   * @tags Document
   * @name GetDocumentCategoryColumns
   * @summary 문서 카테고리 컬럼 조회
   * @request GET:/app/documents/categories/{categoryUuid}/columns
   * @secure
   * @response `200` `BaseResponseListDocumentCategoryColumnDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentCategoryColumnsKey = ({categoryUuid, ...query}: GetDocumentCategoryColumnsParams) => [
    'app',
    'documents',
    'categories',
    categoryUuid,
    'columns',
    query,
  ];

  getDocumentCategoryColumns = async (
    {categoryUuid, ...query}: GetDocumentCategoryColumnsParams,
    params: RequestParams = {},
  ) => {
    const response = await this.http.request<BaseResponseListDocumentCategoryColumnDto, void>({
      path: `/app/documents/categories/${categoryUuid}/columns`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description DocumentCategory UUID를 기준으로 DocumentClass의 name과 uuid를 반환합니다.
   *
   * @tags Document
   * @name GetDocumentClassesByCategory
   * @summary DocumentCategory의 DocumentClass 조회
   * @request GET:/app/documents/categories/{categoryUuid}/classes
   * @secure
   * @response `200` `BaseResponseListNoneOrderDocumentClassDto` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentClassesByCategoryKey = (categoryUuid: string) => [
    'app',
    'documents',
    'categories',
    categoryUuid,
    'classes',
  ];

  getDocumentClassesByCategory = async (categoryUuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListNoneOrderDocumentClassDto, void>({
      path: `/app/documents/categories/${categoryUuid}/classes`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서 검색어 입력시 자동완성 제공
   *
   * @tags Document
   * @name GetArchivesDocumentPage
   * @summary 문서 검색어 자동완성
   * @request GET:/app/documents/autocomplete
   * @secure
   * @response `200` `BaseResponseAutocompleteResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getArchivesDocumentPageKey = (query: GetArchivesDocumentPageParams) => ['app', 'documents', 'autocomplete', query];

  getArchivesDocumentPage = async (query: GetArchivesDocumentPageParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseAutocompleteResponse, void>({
      path: `/app/documents/autocomplete`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * No description
   *
   * @tags Document
   * @name GetDocumentByAdmin
   * @summary 결재자의 문서 상세 조회
   * @request GET:/app/documents/admin/{uuid}
   * @secure
   * @response `200` `BaseResponseDocumentResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getDocumentByAdminKey = (uuid: string) => ['app', 'documents', 'admin', uuid];

  getDocumentByAdmin = async (uuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseDocumentResponse, void>({
      path: `/app/documents/admin/${uuid}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 주어진 UUID에 해당되는 결재 완료 상태의 문서를 삭제합니다. ARCHIVES 문서인 경우 최고관리자와 관리자, 그 외 문서인 경우 최고관리자만 삭제 가능합니다.
   *
   * @tags Document
   * @name DeleteDocument
   * @summary 문서 삭제
   * @request DELETE:/app/documents/{uuid}
   * @secure
   * @response `200` `BaseResponseString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  deleteDocument = async (uuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseString, void>({
      path: `/app/documents/${uuid}`,
      method: 'DELETE',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };
}
